export default __webpack_public_path__ + "86dd55244e8295bf8623a883c74f9d0d.svg";